// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1703562864390
      var cssReload = require("!../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/scss/style.scss
// module id = ./src/scss/style.scss
// module chunks = 270